import * as React from 'react';
import { ContentView } from '@levelapp/softfabric';
import StepViewStyle from './StepViewStyle';
import StepViewModel from './StepViewModel';
import { View, TouchableWithoutFeedback, Text } from 'react-native';
export default class StepView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new StepViewModel(this), new StepViewStyle(this));
    }
    /* RENDERING */
    render() {
        if (this.state.showing) {
            this.binding.getCurrentPage();
        }
        var displayPage = [];
        var start = (this.state.currentPage + 1) - this.props.minimumPage;
        if (start < 0) {
            start = 0;
        }
        else {
            if (start > this.props.numberDisplays - ((this.props.minimumPage * 2) + 1)) {
                start = this.props.numberDisplays - ((this.props.minimumPage * 2) + 1);
            }
            //start;
        }
        console.log(start);
        var end = (this.state.currentPage + 1) + this.props.minimumPage;
        if (end >= this.props.numberDisplays) {
            end = this.props.numberDisplays;
        }
        else {
            end = (this.props.minimumPage * 2) + 1 + start;
        }
        console.log(end);
        if (start != 0 && start - 1 != 0) {
            displayPage.push(React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPressPoint('back'), style: this.style.circle },
                React.createElement(View, { style: this.style.circle },
                    React.createElement(Text, { style: this.style.text }, "..."))));
        }
        for (let i = start; i < end; i++) {
            displayPage
                .push(React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPress(i), key: i, style: [this.style.circle] },
                React.createElement(View, { style: [this.state.currentPage == i && this.state.showing ? [this.style.choose, this.props.styleOfChoosenButton] : this.style.circle] },
                    React.createElement(Text, { style: [this.state.currentPage == i && this.state.showing ? this.style.chooseText : this.style.text] },
                        " ",
                        i + 1))));
        }
        if (end != this.props.numberDisplays && end + 1 != this.props.numberDisplays) {
            displayPage.push(React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPressPoint('front'), style: this.style.circle },
                React.createElement(View, { style: this.style.circle },
                    React.createElement(Text, { style: this.style.text }, "..."))));
        }
        return (React.createElement(View, { style: [this.style.container, this.props.style] },
            start != 0 &&
                React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPress(0), style: this.style.circle },
                    React.createElement(View, { style: this.style.circle },
                        React.createElement(Text, { style: this.style.text }, "1"))),
            displayPage,
            end < this.props.numberDisplays &&
                React.createElement(TouchableWithoutFeedback, { onPress: () => this.binding.onPress(this.props.numberDisplays - 1), style: this.style.circle },
                    React.createElement(View, { style: this.style.circle },
                        React.createElement(Text, { style: this.style.text }, this.props.numberDisplays)))));
    }
}
